import { useSelector } from "react-redux";
import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";
import { Sidebar } from "./pages/Sidebar";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { RegisterSend } from "./pages/RegisterSend";
import { Alerts } from "./components/alerts/Alerts";
import { selectAlert } from "./features/alert.slice";

import { CompaniesInfo } from "./pages/companies/companiesEdit/CompaniesInfo";
import { Companies } from "./pages/companies/Companies";
import { AuthUserRoute } from "./pages/navi/AuthUserRouter";
import { MessageList } from "./pages/companies/messages/MessageList";
import { UsageSituation } from "./pages/usageSituation/UsageSituation";
import { MessageInfo } from "./pages/companies/messages/MessageInfo";
import { CompaniesSidebar } from "./pages/companies/CompaniesSidebar";
import { ReplyButtonPage } from "./pages/companies/replyButtons/ReplyButtonPage";
import { OnlineUrlSettingPage } from "./pages/companies/onlineURLSetting/OnlineUrlSettingPage";
import { LinkMenusPage } from "./pages/companies/linkMenus/LinkMenusPage";
import { MenuSettingsPage } from "./pages/companies/menuSettings/MenuSettingPage";
import { TermsOfUseManagementPage } from "./pages/termsOfUseManagement/TermsOfUseManagement";
import { VideoContentsPage } from "./pages/videoContents/VideoContentsPage";
import { OptionContractSettingPage } from "./pages/companies/optionContractSetting/OptionContractSettingPage";
import { UserIdCardCreatingPage } from "./pages/companies/userIDCardCreating/UserIdCardCreatingPage";

// export const firebase = initializeApp(firebaseConfig);
// export const db = getFirestore(firebase);

const App = () => {
  const alart = useSelector(selectAlert);
  return (
    <>
      {alart.isOpen && (
        <Alerts color={alart.color} text={alart.text} sbuText={alart.subText} />
      )}

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AuthUserRoute><Sidebar /></AuthUserRoute>}>
            {/* 団体リスト */}
            <Route path="companies" element={<Companies />} />
            {/* 団体管理 */}
            <Route path="companies/:tenantId/" element={<CompaniesSidebar />}>
              {/* 団体詳細 */}
              <Route path="info" element={<CompaniesInfo />} />
              {/* お知らせ */}
              <Route path="message" element={<MessageList />} />
              {/* お知らせ詳細 */}
              <Route path="message/:messageId/info" element={<MessageInfo />} />
              {/* 返信ボタン設定 */}
              <Route path="replyButtons" element={<ReplyButtonPage />} />
              {/* ミーティングURL設定 */}
              <Route path="onlineUrlSetting" element={<OnlineUrlSettingPage />} />
              {/* 連携メニュー */}
              <Route path="linkMenus" element={<LinkMenusPage />} />
              {/* メニュー設定 */}
              <Route path="menuSettings" element={<MenuSettingsPage />} />
              {/* オプション契約設定 */}
              <Route path="optionContractSetting" element={<OptionContractSettingPage />} />
              {/* 利用者IDカード出力 */}
              <Route path="userIdCardCreating" element={<UserIdCardCreatingPage />} />
            </Route>
            {/* 動画コンテンツ管理 */}
            <Route path="videoContents" element={<VideoContentsPage />} />
            {/* 利用状況 */}
            <Route path="usageSituation" element={<UsageSituation />} />
            {/* 利用規約・個人情報 */}
            <Route path="termsOfUseManagement" element={<TermsOfUseManagementPage />} />
            {/* 新規登録 */}
            <Route path="register" element={<Register />} />
            <Route path="register/send" element={<RegisterSend />} />
          </Route>
          {/* ログイン */}
          <Route path="/login" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
